import clsx from "clsx";
import React, { FunctionComponent } from "react";

import { TabButton } from "../../../../../ui/Tabs/TabButton";
import { TabsGroup } from "../../../../../ui/Tabs/TabsGroup";
import { SnowflakeIcon } from "../../../../../ui/icons/SnowflakeIcon";
import { SunIcon } from "../../../../../ui/icons/SunIcon";
import { secondaryTireFilters } from "../secondaryTireFilters";
import { useSeasonList } from "./useSeasonList";
import { useTireSeason } from "./useTireSeason";

export const TireQuickSeasonFilters: FunctionComponent = () => {
  const [selectedSeason, setSelectedSeason] = useTireSeason();
  const seasonList = useSeasonList();
  return (
    <TabsGroup id="quick-season-tabs">
      {seasonList.map(({ name, value }) => (
        <TabButton
          onClick={(): void => {
            setSelectedSeason(value, secondaryTireFilters);
          }}
          aria-label="selectSeason"
          className={clsx(value !== 1 && "md:pl-2")}
          key={value}
          selected={selectedSeason === value}
        >
          {value === 0 && <SnowflakeIcon />}
          {value === 2 && <SunIcon />}
          <span className={clsx(value !== 1 && "hidden sm:inline")}>
            {name}
          </span>
        </TabButton>
      ))}
    </TabsGroup>
  );
};
